import React from 'react';
import styled from 'styled-components';

function SecurityChecklist({ onClose }) {
  return (
    <Div>
      <div className="wp__menubar">
        <span className="wp__menu">File</span>
        <span className="wp__menu">Edit</span>
        <span className="wp__menu">View</span>
        <span className="wp__menu">Insert</span>
        <span className="wp__menu">Format</span>
        <span className="wp__menu">Help</span>
      </div>
      <div className="wp__toolbar">
        <button className="wp__toolbar__btn" disabled>New</button>
        <button className="wp__toolbar__btn" disabled>Open</button>
        <button className="wp__toolbar__btn" disabled>Save</button>
        <div className="wp__toolbar__sep" />
        <button className="wp__toolbar__btn" disabled>Print</button>
        <button className="wp__toolbar__btn" disabled>Preview</button>
        <div className="wp__toolbar__sep" />
        <button className="wp__toolbar__btn" disabled>Find</button>
        <div className="wp__toolbar__sep" />
        <button className="wp__toolbar__btn" disabled>Cut</button>
        <button className="wp__toolbar__btn" disabled>Copy</button>
        <button className="wp__toolbar__btn" disabled>Paste</button>
        <button className="wp__toolbar__btn" disabled>Undo</button>
      </div>
      <div className="wp__format">
        <select className="wp__format__font" disabled>
          <option>Times New Roman</option>
        </select>
        <select className="wp__format__size" disabled>
          <option>12</option>
        </select>
        <span className="wp__format__btn wp__format__btn--bold" title="Bold">B</span>
        <span className="wp__format__btn wp__format__btn--italic" title="Italic">I</span>
        <span className="wp__format__btn wp__format__btn--underline" title="Underline">U</span>
        <span className="wp__format__btn" title="Color">A</span>
        <div className="wp__format__sep" />
        <span className="wp__format__btn">{'\u2261'}</span>
        <span className="wp__format__btn">{'\u2261'}</span>
        <span className="wp__format__btn">{'\u2022'}</span>
      </div>
      <div className="wp__ruler">
        <div className="wp__ruler__markings">
          {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(n => (
            <span key={n} className="wp__ruler__mark">{n}</span>
          ))}
        </div>
      </div>
      <div className="wp__content">
        <div className="wp__doc">
          <h1 className="wp__doc__title">CYBER SECURITY ASSESSMENT</h1>
          <h2 className="wp__doc__subtitle">Pemberton & Associates Solicitors LLP</h2>
          <p className="wp__doc__meta">Internal Review | Strictly Confidential | Last Reviewed: "sometime last year"</p>

          <table className="wp__table">
            <thead>
              <tr>
                <th className="wp__th wp__th--status">Status</th>
                <th className="wp__th wp__th--item">Requirement</th>
                <th className="wp__th wp__th--notes">Notes</th>
              </tr>
            </thead>
            <tbody>
              <Row status="FAIL" item="Multi-Factor Authentication (2FA)" note="The partners voted against it. Said it 'takes too long to log in'." />
              <Row status="FAIL" item="Password Policy Enforcement" note="Still using the firm name + year of establishment. 'Pemberton1987' is not a strong password." />
              <Row status="FAIL" item="Endpoint Detection & Response (EDR)" note="Using free Windows Defender. Last update unknown." />
              <Row status="FAIL" item="Email Security (SPF/DKIM/DMARC)" note="IT person 'set it up years ago'. SPF record has syntax errors." />
              <Row status="FAIL" item="Cyber Essentials Certification" note="'Sounds expensive.' Required for Law Society compliance since 2024." />
              <Row status="FAIL" item="Staff Security Awareness Training" note="One partner watched a YouTube video about phishing. Counts, right?" />
              <Row status="FAIL" item="Firewall Configuration" note="Default admin password. Port 3389 (RDP) open to the internet." />
              <Row status="FAIL" item="Data Backup Strategy" note="USB hard drive plugged into the server. Last backup: unknown." />
              <Row status="FAIL" item="GDPR Data Protection" note="Client files in a shared Dropbox folder. Personal email used for client comms." />
              <Row status="FAIL" item="Incident Response Plan" note="Plan is 'call Gary from the computer shop'." />
              <Row status="FAIL" item="MDR / Security Monitoring" note="'What is MDR?' Nothing is being monitored. At all." />
              <Row status="PASS" item="Antivirus Installed" note="Norton. Subscription expired 14 March 2022. Still showing the icon though." />
            </tbody>
          </table>

          <div className="wp__score">
            <div className="wp__score__result">OVERALL SCORE: 1 / 12</div>
            <div className="wp__score__rating">Rating: CRITICAL RISK</div>
          </div>

          <div className="wp__findings">
            <h3>Key Findings</h3>
            <p>This firm handles sensitive client data including financial records, trust deeds, property transactions, and personal information protected under GDPR and the Solicitors Regulation Authority (SRA) Standards and Regulations.</p>
            <p>With an RDP port open to the internet, no EDR, expired antivirus, and no backup strategy, the firm is one phishing email away from a ransomware attack that would encrypt every client file on the network.</p>
            <p>The SRA requires law firms to have appropriate cyber security measures in place. The current state of IT security at this firm does not meet these requirements and represents a significant risk to the practice, its clients, and its professional indemnity insurance.</p>
          </div>

          <div className="wp__recommendations">
            <h3>Recommended Actions</h3>
            <p>All of the above can be resolved with a managed IT and security partner.</p>
            <p className="wp__rec__list">
              {'  - '}Managed IT Support and Patch Management{'\n'}
              {'  - '}Microsoft 365 Security (Conditional Access, MFA, DLP){'\n'}
              {'  - '}Managed Detection & Response (MDR){'\n'}
              {'  - '}Anti-Ransomware with Immutable Backups{'\n'}
              {'  - '}Cyber Essentials Certification{'\n'}
              {'  - '}Staff Security Awareness Training{'\n'}
              {'  - '}Email Security Configuration{'\n'}
              {'  - '}GDPR Compliance Review{'\n'}
              {'  - '}Incident Response Planning{'\n'}
            </p>
          </div>

          <div className="wp__cta">
            <div className="wp__cta__name">Dead Simple Computing</div>
            <div className="wp__cta__phone">0118 359 2220</div>
            <div className="wp__cta__web">deadsimplecomputing.co.uk</div>
            <div className="wp__cta__tagline">Managed IT | Cyber Security | Microsoft 365</div>
            <div className="wp__cta__sub">Reading, Berkshire</div>
          </div>
        </div>
      </div>
    </Div>
  );
}

function Row({ status, item, note }) {
  return (
    <tr className={status === 'FAIL' ? 'wp__row--fail' : 'wp__row--pass'}>
      <td className="wp__td wp__td--status">
        <span className={`wp__badge wp__badge--${status.toLowerCase()}`}>{status}</span>
      </td>
      <td className="wp__td wp__td--item">{item}</td>
      <td className="wp__td wp__td--notes">{note}</td>
    </tr>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #ece9d8;
  font-family: Tahoma, sans-serif;
  font-size: 11px;

  .wp__menubar {
    display: flex;
    background: #ece9d8;
    padding: 2px 4px;
    border-bottom: 1px solid #aaa;
  }
  .wp__menu {
    padding: 2px 8px;
    font-size: 11px;
    cursor: default;
    &:hover { background: #316ac5; color: white; }
  }
  .wp__toolbar {
    background: linear-gradient(to bottom, #fafafa, #e4e4e4);
    padding: 2px 4px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #aaa;
    gap: 1px;
    flex-wrap: wrap;
  }
  .wp__toolbar__btn {
    padding: 2px 6px;
    border: 1px solid transparent;
    border-radius: 2px;
    background: none;
    font-family: Tahoma, sans-serif;
    font-size: 10px;
    cursor: default;
    &:hover:not(:disabled) { border-color: #bbb; background: #fff; }
    &:disabled { opacity: 0.5; }
  }
  .wp__toolbar__sep {
    width: 1px;
    height: 18px;
    background: #bbb;
    margin: 0 3px;
  }
  .wp__format {
    background: linear-gradient(to bottom, #f5f5f0, #e8e8e0);
    padding: 2px 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    border-bottom: 1px solid #ccc;
  }
  .wp__format__font {
    font-size: 10px;
    font-family: Tahoma, sans-serif;
    width: 130px;
    height: 18px;
  }
  .wp__format__size {
    font-size: 10px;
    font-family: Tahoma, sans-serif;
    width: 40px;
    height: 18px;
  }
  .wp__format__btn {
    width: 20px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    border: 1px solid transparent;
    cursor: default;
    &:hover { border-color: #bbb; background: #fff; }
    &--bold { font-weight: bold; }
    &--italic { font-style: italic; }
    &--underline { text-decoration: underline; }
  }
  .wp__format__sep {
    width: 1px;
    height: 14px;
    background: #bbb;
  }
  .wp__ruler {
    background: white;
    border-bottom: 1px solid #ccc;
    height: 18px;
    overflow: hidden;
  }
  .wp__ruler__markings {
    display: flex;
    justify-content: space-between;
    padding: 2px 20px;
    font-size: 8px;
    color: #666;
  }
  .wp__ruler__mark {
    width: 10px;
    text-align: center;
  }
  .wp__content {
    flex: 1;
    overflow-y: auto;
    background: #808080;
    padding: 16px;
  }
  .wp__doc {
    background: white;
    max-width: 700px;
    margin: 0 auto;
    padding: 40px 50px;
    box-shadow: 2px 2px 8px rgba(0,0,0,0.3);
    font-family: 'Times New Roman', Times, serif;
    font-size: 12px;
    line-height: 1.6;
  }
  .wp__doc__title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin: 0 0 4px;
    color: #000;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  .wp__doc__subtitle {
    font-size: 14px;
    text-align: center;
    margin: 0 0 4px;
    color: #333;
    font-weight: normal;
  }
  .wp__doc__meta {
    text-align: center;
    font-size: 10px;
    color: #999;
    margin-bottom: 20px;
    font-style: italic;
  }
  .wp__table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    font-family: Tahoma, sans-serif;
    font-size: 10px;
  }
  .wp__th {
    background: #003399;
    color: white;
    padding: 4px 6px;
    text-align: left;
    font-size: 10px;
    &--status { width: 50px; }
    &--item { width: 200px; }
    &--notes { }
  }
  .wp__td {
    padding: 4px 6px;
    border-bottom: 1px solid #eee;
    vertical-align: top;
    &--status { text-align: center; }
  }
  .wp__row--fail { }
  .wp__row--pass { color: #999; text-decoration: line-through; }
  .wp__badge {
    font-size: 8px;
    font-weight: bold;
    padding: 1px 4px;
    border-radius: 2px;
    &--fail { background: #cc0000; color: white; }
    &--pass { background: #00aa00; color: white; }
  }
  .wp__score {
    text-align: center;
    margin: 20px 0;
    padding: 12px;
    border: 2px solid #cc0000;
    background: #fff5f5;
  }
  .wp__score__result {
    font-size: 20px;
    font-weight: bold;
    color: #cc0000;
    font-family: Tahoma, sans-serif;
  }
  .wp__score__rating {
    font-size: 12px;
    color: #cc0000;
    font-weight: bold;
    font-family: Tahoma, sans-serif;
  }
  .wp__findings {
    margin-bottom: 16px;
    h3 {
      font-size: 13px;
      color: #003399;
      margin: 0 0 6px;
      border-bottom: 1px solid #003399;
      padding-bottom: 2px;
    }
    p {
      margin: 0 0 8px;
      text-align: justify;
    }
  }
  .wp__recommendations {
    margin-bottom: 16px;
    h3 {
      font-size: 13px;
      color: #003399;
      margin: 0 0 6px;
      border-bottom: 1px solid #003399;
      padding-bottom: 2px;
    }
    p { margin: 0 0 8px; }
  }
  .wp__rec__list {
    white-space: pre-wrap;
    font-family: Tahoma, sans-serif;
    font-size: 11px;
    line-height: 1.6;
  }
  .wp__cta {
    text-align: center;
    padding: 16px;
    border: 1px solid #003399;
    background: #f5f8ff;
    margin-top: 20px;
  }
  .wp__cta__name {
    font-size: 16px;
    font-weight: bold;
    color: #003399;
    font-family: Tahoma, sans-serif;
  }
  .wp__cta__phone {
    font-size: 18px;
    font-weight: bold;
    color: #003399;
    font-family: Tahoma, sans-serif;
  }
  .wp__cta__web {
    font-size: 11px;
    color: #0066cc;
    font-family: Tahoma, sans-serif;
  }
  .wp__cta__tagline {
    font-size: 10px;
    color: #666;
    margin-top: 4px;
    font-family: Tahoma, sans-serif;
  }
  .wp__cta__sub {
    font-size: 9px;
    color: #999;
    font-family: Tahoma, sans-serif;
  }
`;

export default SecurityChecklist;
